import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { UpdateSupportMeetingContract } from '../models/update-support-meeting-contract';

export const UpdateSupportMeeting = createAsyncThunk(
    'engagementMeetings/updateSupportMeeting',
    async (
        {
            meetingEventId,
            contract,
        }: { meetingEventId: number; contract: UpdateSupportMeetingContract },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `/api/Marketplace/MarketplaceMeetings/${meetingEventId}`,
                contract
            );

            if (response.status !== 200 && response.status !== 204) {
                createNotification(
                    'Could not update the meeting at the moment.',
                    'error'
                );
                throw new Error('Failed to update support meeting');
            }

            createNotification('Meeting updated successfully.', 'success');
            return { meetingEventId };
        } catch (error) {
            createNotification(
                'An error occurred while updating the meeting.',
                'error'
            );
            throw error;
        }
    }
);
